import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.css']
})
export class CustomSnackbarComponent implements OnInit {
  /**
   * Icon Selections:
   * error = 'ion-close'
   * info = 'ion-information'
   * success = 'ion-checkmark'
   * warning = 'ion-alert'
   */

  public type: string;
  public message: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    switch (data.type) {
      case 'success':
        this.type = 'checkmark';
        break;
      case 'error':
        this.type = 'close';
        break;
      case 'warning':
        this.type = 'alert';
        break;
      case 'info':
        this.type = 'information';
        break;
    }
    this.message = data.message;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/layout/custom-snackbar/custom-snackbar.component.ts